import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { FeedService } from '../../service/feed.service';
import { ConnectFeedDialogComponent } from '../connect-feed-dialog/connect-feed-dialog.component';

@Component({
  standalone: true,
  selector: 'app-feed-connections',
  templateUrl: './feed-connections.component.html',
  styleUrls: ['./feed-connections.component.scss'],
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule]
})
export class FeedConnectionsComponent {

  constructor(
    public feedService: FeedService,
    private dialog: MatDialog
  ) { }

  async ngOnInit() {
    await this.feedService.loadFeedDestinations();
    await this.feedService.loadTenantFeedAccounts();
  }

  getConnectionStatus(destCode: string) {
    return this.feedService.accounts().find(a => a.code === destCode && a.is_connected == true);
  }

  openConnectDialog(destination: any) {
    const dialogRef = this.dialog.open(ConnectFeedDialogComponent, {
      width: '450px',
      data: { destination }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        await this.feedService.connectFeedAccount(result);
        await this.feedService.loadTenantFeedAccounts();
      }
    });
  }

  async disconnect(destCode: string) {
    if (!confirm('Disconnect this feed?')) return;
    await this.feedService.disconnectFeedAccount(destCode);
    await this.feedService.loadTenantFeedAccounts();
  }

  async goToMappings(destCode: string) {
    window.location.href = `/admin/feed-mapping/${destCode}`;
  }
}
